import React from "react";
import "./about.css";


const About = () => {
  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero">
        <h1>About Us</h1>
        <p>
          Welcome to <strong>Around the Globe</strong>, your trusted partner in discovering the world's most beautiful destinations. Let us take you on a journey of a lifetime!
        </p>
      </section>

      {/* About Section */}
      <section className="about-details">
        <div className="about-image">
          <img
            src="/assets/images/slider/1.jpg"
            alt="About Us"
            className="responsive-img"
          />
        </div>
        <div className="about-content">
          <h1>Who We Are</h1>
          <p>
            At <strong>Around the Globe</strong>, we are passionate about making your travel dreams come true. From exploring iconic landmarks to experiencing hidden gems, we specialize in curating unique journeys tailored just for you.
          </p>
          <p>
            With a team of seasoned travel experts, we ensure every step of your journey is planned to perfection, offering you an experience that is both seamless and unforgettable.
          </p>
        </div>
      </section>

      {/* Mission Section */}
      <section className="about-mission">
        <h1>Our Mission</h1>
        <p>
          Our mission is to inspire a love for travel and help you connect with the wonders of the world. At <strong>Around the Globe</strong>, we believe every journey is an opportunity to create lifelong memories and meaningful experiences.
        </p>
      </section>

      {/* Call-to-Action */}
      <section className="about-cta">
        <h2>Let’s Explore Together</h2>
        <p>
          Discover the joy of traveling with <strong>Around the Globe</strong>. Let us guide you to destinations that will leave you inspired and enriched. Start your adventure today!
        </p>
        <button className="cta-button">Plan Your Journey</button>
      </section>
    </div>
  );
};

export default About;
